<div (click)="ref.dismiss()" style="display: flex; border-radius: inherit; cursor: pointer; width: 100%;z-index: 999999">
    <div class="status-bar-icon">
        <mat-icon>{{ data.icon || 'info' }}</mat-icon>
    </div>
    <div class="status-bar-content">{{ data.message }}</div>
</div>
